import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export default class TextIconCarousel extends HTMLElement {
    /**
     * Class constructor
    */
    constructor() {
        super();
        this.carousel = this.querySelector('.swiper');
        this.arrowNext = this.querySelector('.swiper-button-next');
        this.arrowPrev = this.querySelector('.swiper-button-prev');
        this.scrollbar = this.querySelector('.swiper-scrollbar');

        this.init();
    }

    init() {
        this.createSwiper();
    }

    createSwiper() {
        this.swiper = new Swiper(this.carousel, {
            slidesPerView: 1.6,
            spaceBetween: 10,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.6
                },
                1024: {
                    slidesPerView: 3.6
                },
                1280: {
                    slidesPerView: 4.6
                },
                1440: {
                    slidesPerView: 6
                }
            }
        });
    }
}

customElements.define('text-icon-carousel', TextIconCarousel);
